import http from 'axios'

export const listServices = () => ({
  type: 'HOSTED_VOICE/LIST_SERVICES',
  payload: http({
    method: 'GET',
    url: 'api/v1/services/hosted-voice',
  }),
})



// WEBPACK FOOTER //
// src/features/Services/HostedVoice/HostedVoice.actions.ts